import { str } from './str.js';
export const util = (function() {
    
    /**
     * Listen to document.readyState for function to execute
     * @param {function} callback 
     * @returns {UI}
     */
    function ready(callback){
        if (document.readyState === 'complete' || document.readyState === 'interactive'  ) 
            
                setTimeout(callback, 500)
        else
            document.addEventListener('DOMContentLoaded',callback)
        return ui
    }
    /**
     * Boot class object; should contain boot methods and endpoint property to match with url.pathname
     * @param {object} obj 
     * @param {array} methods 
     * @returns {UI}
     */
     function boot(obj){
        if(Array.isArray(obj))
            return this.bootGroup(obj) // call bootGroup for array
        
        if(window.ui) ui.boot = obj
        const url = new URL(location.href),
              hash = url.hash,
              path = hash ? hash.replace('#','/').split('/') : url.pathname.split('/'),
              instance = obj[path[1]] ? new obj[path[1]]() : undefined,
              call = (method,id) => {
                if(typeof method === 'string'){
                    if(instance[method]) return instance[method](id) // call module class method 
                    if(this[method]) return this[method]() // call UI method
                } 
                if(typeof method === 'function') return method(id) // call function
              }
        console.log(obj,path[1],path[2],instance)
        if(!instance) return console.warn(`No available instance for endpoint '${path[1]}'`)
        if((path[1] === instance.endpoint)) {
            ui.endpoint = instance.endpoint
            instance.boot.forEach( method => {
                if(typeof method === 'object'){
                    Object.keys(method).forEach( key => {
                        if(key===path[2])// match boot property 
                            method[path[2]].forEach(item=>call(item))
                        
                        if(!path[2] && key === 'index') //index
                            method[key].forEach(item=>call(item))
                        
                        if(str.isUUID(path[2]) && key === 'show') //show
                            method[key].forEach(item=>call(item,path[2]))
                    })
                
                }
                call(method)
            })
        }
        return ui
    }
    /**
     * Boot a group of class objects
     * @param {*} objs 
     */
    function bootGroup(objs){
        
        objs.forEach(obj => this.boot(obj))
    }
    /**
     * Add delay to a function
     * @param {*} callback 
     * @param {*} ms 
     * @returns 
     */
    function delay(callback, ms) {
        let timer = 0
        return function() {
            clearTimeout(timer)
            timer = setTimeout(function () {
                callback.apply(this, arguments)
            }, ms || 0)
        }
    }
    /**
     * hashChange event listener router, assigns hash href to all a elements with href attribute,
     * and calls endpoint with the same href with fetch and loads the requested page and calls 
     * boot moule method for requested endpoint.
     * 
     * @param {object} options Options object
     * @returns {UI}
     */
    function hashRoute(options){
        let url
        const a_href_elements = () => document.querySelectorAll('a[href]'),
              body = document.querySelector('body'),
              main = document.querySelector('main'),
              header = document.querySelector('header .container'),
              assign = () => {
                a_href_elements().forEach(element => {
                    const href = element.getAttribute('href')
                    try{
                        url = new URL(href)
                    }catch(error){
                        //console.warn('Could not parse ' + href + ', using window.location to parse url')
                        url = new URL(location.protocol +'//'+location.hostname+href)
                    }
                    if(!url.hash) 
                        element.setAttribute('href', ('#'+url.pathname).replace('#/','#'))
                })
            },
        get = (path = location.hash.replace('#', '')) => {
            a_href_elements().forEach(element => element.classList.remove('active'))
		    document.querySelectorAll('[href="'+location.hash.split('/')[0]+'"').forEach(element => element.classList.add('active'))
            main.classList.add('fade')
            main.classList.remove('show')
            header.classList.add('fade')
            header.classList.remove('show')  
            fetch(path).then((response) => {
                if (response.status !== 200) {
                    ui.modal('Error '+response.status, response.statusText)
                    if(options?.error) options.error(response)
                    return
                }else{
                    return response.text()
                }
            }).then((html) => {
                const parse = new DOMParser().parseFromString(html, 'text/html'),
                      body_ = parse.querySelector('body'),
                      main_ = parse.querySelector('main'),
                      header_ = parse.querySelector('header .container')
                
                if(main){
                    main.innerHTML = main_.innerHTML
                    header.innerHTML = header_.innerHTML
                    main.classList.add('show')
                    header.classList.add('show')  
                }else{
                    body.innerHTML = body_.innerHTML
                }
                
                assign()
                boot(ui.boot)
            }).catch((err) => {
                console.log(err)
            })
        },
        listen = () => {
            window.addEventListener('hashchange', () => {
                get()
            })
        }
        assign()
        listen()
        get()
        return ui
    }

    function addMixin(target, ...sources) {
        sources.forEach(source => {
          let descriptors = Object.keys(source).reduce((descriptors, key) => {
            descriptors[key] = Object.getOwnPropertyDescriptor(source, key)
            return descriptors;
          }, {});
          Object.getOwnPropertySymbols(source).forEach(sym => {
            let descriptor = Object.getOwnPropertyDescriptor(source, sym)
            if (descriptor.enumerable) {
              descriptors[sym] = descriptor
            }
          })
          Object.defineProperties(target, descriptors)
        })
        return target
    }
    return {
        ready,
        boot,
        bootGroup,
        delay,
        hashRoute,
        addMixin
    }
})()